<template>
	<div class="tender">
		<ul class="tenderList clearfloat">
			<li>
				<div class="left">
					<div class="icon"><span></span></div>
				</div>
				<div class="right">
					<h3><a href="">中国（绵阳）科技城游仙军民融合产业园</a></h3>
					<p class="multi-line">我公司委托四川久安工程管理有限公司（以下简称“代理机构”）组织招标的“中国（绵阳）科技城游仙军民融合...</p>
					<a class="tenderListD" href="">查看详细</a>
				</div>
			</li>
			<li>
				<div class="left">
					<div class="icon"><span></span></div>
				</div>
				<div class="right">
					<h3><a href="">中国（绵阳）科技城游仙军民融合产业园</a></h3>
					<p class="multi-line">四川久安工程管理有限公司受绵阳交发恒通建设工程有限责任公司委托，拟对“中国（绵阳）科技城游仙军民...</p>
					<a class="tenderListD" href="">查看详细</a>
				</div>
			</li>
			<li>
				<div class="left">
					<div class="icon"><span></span></div>
				</div>
				<div class="right">
					<h3><a href="">城建攻坚、集中发展区攻坚项目行洪论证</a></h3>
					<p class="multi-line">我公司委托四川久安工程管理有限公司（以下简称“代理机构”）组织招标的“城建攻坚、集中发展区攻坚项目行...</p>
					<a class="tenderListD" href="">查看详细</a>
				</div>
			</li>
			<li>
				<div class="left">
					<div class="icon"><span></span></div>
				</div>
				<div class="right">
					<h3><a href="">城建攻坚、集中发展区攻坚项目行洪论证</a></h3>
					<p class="multi-line">四川久安工程管理有限公司受绵阳交发恒通建设工程有限责任公司委托，拟对“城建攻坚....</p>
					<a class="tenderListD" href="">查看详细</a>
				</div>
			</li>
			<li>
				<div class="left">
					<div class="icon"><span></span></div>
				</div>
				<div class="right">
					<h3><a href="">绵阳市高等级公路开发有限责任公司</a></h3>
					<p class="multi-line">18年3月30日，我司组织开展了工程招标代理和物资采购代理机构比选，经评审小组评审...</p>
					<a class="tenderListD" href="">查看详细</a>
				</div>
			</li>
			<li>
				<div class="left">
					<div class="icon"><span></span></div>
				</div>
				<div class="right">
					<h3><a href="">绵阳绕城高速公路南环线项目永明互通立交</a></h3>
					<p class="multi-line">绵阳绕城高速公路南环线项目（以下简称“本项目”）由四川省发展和改革委员会以...</p>
					<a class="tenderListD" href="">查看详细</a>
				</div>
			</li>
		</ul>

		<div class="page">
			<em>&lt;</em>
			<a class="active" href="javascript:">1</a>
			<a href="javascript:">2</a>
			<a href="javascript:">3</a>
			<a href="javascript:">4</a>
			<a href="javascript:">5</a>
			<a href="javascript:">6</a>
			<em>&gt;</em>
		</div>
	</div>
</template>

<script>
/**
 * 描述
 * @description 描述
 * @property {String}
 * @example <aby-botton-line  />
 */

export default {
	props: {},
	data() {
		return {};
	},
	computed: {},
	created(obj) {
		// 页面第一次加载执行，参数为上个页面传递的数据，参数类型为Object
	},
	methods: {},
	watch: {
		obj: {
			//监听的对象
			deep: true, //深度监听设置为 true
			handler: function(newV, oldV) {
				console.log('watch中：', newV);
			}
		}
	}
};
</script>

<style scoped></style>
